<template>
  <el-table-column
    prop="is_active"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.is_active"
        size="small"
        type="success"
      >
        Aktív
      </el-tag>
      <el-tag
        v-if="!scope.row.is_active"
        size="small"
        type="danger"
      >
        Inaktív
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'is_active',
};
</script>
